// services/lesionImagePlacement.ts — SKIN-576: re-file a closed visit's photos from the web.
import axios from 'axios';
import {
    AttachPhotoRequest,
    MovePhotoRequest,
    VisitPhotoPlacementDto,
} from '../pages/hospital/photoPlacement/photoPlacement';

const VISITS_BASE_URL = import.meta.env.VITE_APP_API_URL + '/visits';

const imagesUrl = (uuidInvestigation: string, uuidVisit: string, action: string) =>
    `${VISITS_BASE_URL}/investigation/${uuidInvestigation}/visit/${uuidVisit}/web/images/${action}`;

const auth = () => ({ headers: { Authorization: localStorage.getItem('jwt') ?? '' } });

/**
 * GET .../web/images/unassigned — the visit's lesions (the targets, with the photos each slot
 * holds) and the orphan photos the visit may own. The server's default window applies.
 */
export async function fetchVisitPhotoPlacement(uuidInvestigation: string, uuidVisit: string): Promise<VisitPhotoPlacementDto> {
    const response = await axios.get(imagesUrl(uuidInvestigation, uuidVisit, 'unassigned'), auth());
    const data = response.data;
    // A shape we do not recognise is a failed read, not a visit with no photos.
    if (!Array.isArray(data?.images) || !Array.isArray(data?.lesions)) throw new Error('unassigned: unexpected response');
    return data;
}

/** POST .../web/images/move. Rejects with the AxiosError on refusal (`response.data.error`). */
export async function movePhoto(uuidInvestigation: string, uuidVisit: string, move: MovePhotoRequest): Promise<unknown> {
    const response = await axios.post(imagesUrl(uuidInvestigation, uuidVisit, 'move'), move, auth());
    return response.data;
}

/**
 * POST .../web/images/attach. `confirm: true` is sent here, not by the caller: the only path
 * that reaches this function is the dialog's confirmation step, which is what the flag attests.
 */
export async function attachPhoto(uuidInvestigation: string, uuidVisit: string, attach: AttachPhotoRequest): Promise<unknown> {
    const response = await axios.post(imagesUrl(uuidInvestigation, uuidVisit, 'attach'), { ...attach, confirm: true }, auth());
    return response.data;
}
